/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpRightIcon64Regular = forwardRef('ArrowAUpRightIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M20.5 10a1.5 1.5 0 1 0 0 3h26c.695 0 1.353.157 1.94.439l-36 36a1.5 1.5 0 0 0 2.12 2.122L50.562 15.56c.282.587.439 1.245.439 1.94v26a1.5 1.5 0 1 0 3 0v-26a7.5 7.5 0 0 0-7.5-7.5h-26Z" })));
});
